// Need these types for React Native Webview and for in webview Navigation
declare global {
  interface Window {
    // Injected by React Native Webview
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}
type WebViewLinkEvent = {
  eventName: 'link';
  eventData: {
    href: URL;
  };
};

type WebViewEvent = WebViewLinkEvent;

// Used to communicate with the native app, which loads the page in a webview.
// Won't affect normal browser usage.
export function postDataToWebview(data: any): void {
  const w: any = window;
  if (w.ReactNativeWebView && w.ReactNativeWebView.postMessage) {
    // used by 'react-native-webview'
    w.ReactNativeWebView.postMessage(JSON.stringify(data));
  } else {
    // used by 'react-native'
    window.postMessage(JSON.stringify(data), '*');
  }
}
const postToReactNative = (stringifiedData: string): void => {
  if (window.ReactNativeWebView) {
    /**
     * Anding a route to post message on android leads it to be being undefined for some reason
     * https://github.com/react-native-webview/react-native-webview/issues/1829
     */
    window.ReactNativeWebView.postMessage(stringifiedData);
  }
};
/** Send a message to the React Native app */
const sendWebViewEvent = (message: WebViewEvent): void => {
  const stringifiedData = JSON.stringify(message);
  postToReactNative(stringifiedData);
};
/** Tells the native app to open an arbitrary link (e.g. in a Safari view) */
export const sendWebViewLinkEvent = (href: URL): void =>
  sendWebViewEvent({ eventName: 'link', eventData: { href } });

export const isOpendoorAppEvoWebView =
  navigator.userAgent.indexOf('OpendoorAppWebView/EvolvedWebView') > -1;
